import React from "react";
import { connect } from "react-redux";
import { FaTimes } from "react-icons/fa";
import { Translate } from "react-redux-i18n";
import AdComment from "./AdComment";
import MiniLoader from "./MiniLoader";
import * as actions_ad from "../redux/actions/adActions";

class ReelCommentsSheet extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen && this.props.productId) {
      this.loadAd();
    }
  }

  loadAd = () => {
    const { productId, user_id, token } = this.props;
    if (!productId || !token) return;

    this.props.LoadAd({
      params: {
        goder_id: productId,
        id: user_id,
        lang: this.props.lang,
      },
      token,
    });
  };

  render() {
    const { isOpen, onClose, loading, ad, productId } = this.props;

    if (!isOpen) return null;

    const isReady = ad?.Id && String(ad.Id) === String(productId);

    return (
      <div className="reels-comments-sheet" role="dialog" aria-modal="true">
        <button
          type="button"
          className="reels-comments-sheet__backdrop"
          onClick={onClose}
          aria-label="Close"
        />
        <div className="reels-comments-sheet__panel">
          <header className="reels-comments-sheet__header">
            <h3>
              <Translate value="comments" />
            </h3>
            <button type="button" className="reels-comments-sheet__close" onClick={onClose}>
              <FaTimes />
            </button>
          </header>
          <div className="reels-comments-sheet__body">
            {loading && !isReady ? (
              <MiniLoader />
            ) : isReady ? (
              <AdComment />
            ) : (
              <p className="reels-comments-sheet__empty">
                <Translate value="try_later" />
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.ad.item,
    loading: reducer.ad.loading,
    lang: reducer.i18n.locale,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadAd: (data) => dispatch(actions_ad.loadItem(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReelCommentsSheet);
